var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "singleDisbursementModal" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            title: _vm.dialogTitle,
            width: "910px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("merchantAccount.beneficiary_account_information")
                ) +
                " "
            ),
          ]),
          _c(
            "div",
            { staticClass: "form-container" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    "status-icon": "",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "merchantAccount.recipient_channel"
                                ),
                                prop: "disbursement_channel",
                                rules: [
                                  {
                                    required: true,
                                    message:
                                      "Receiving channel cannot be empty",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "select-item",
                                  attrs: {
                                    disabled: _vm.disabled,
                                    filterable: "",
                                    clearable: "",
                                  },
                                  on: { change: _vm.disbursementChannelChange },
                                  model: {
                                    value: _vm.form.disbursement_channel,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "disbursement_channel",
                                        $$v
                                      )
                                    },
                                    expression: "form.disbursement_channel",
                                  },
                                },
                                _vm._l(_vm.bankList, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name_with_full_bank,
                                      value: item.bank_code,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11, offset: 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "merchantAccount.account_holder_name"
                                ),
                                prop: "disbursement_name",
                                rules: [
                                  {
                                    required: true,
                                    message:
                                      "Account Holder Name cannot be empty",
                                    trigger: "blur",
                                  },
                                  {
                                    validator: _vm.checkWhitespace,
                                    trigger: "blur",
                                  },
                                  { validator: _vm.checkName, trigger: "blur" },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "search-frame",
                                attrs: {
                                  disabled: _vm.disabled,
                                  placeholder: "Enter Account Holder Name",
                                  maxlength: "100",
                                  autocomplete: "off",
                                  clearable: "",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.form.disbursement_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "disbursement_name", $$v)
                                  },
                                  expression: "form.disbursement_name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.showBeneficiaryType
                    ? _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 11, offset: 2 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "merchantAccount.recipient_account_type"
                                    ),
                                    prop: "beneficiary_type",
                                    rules: [
                                      {
                                        required: true,
                                        message: "Account Type cannot be empty",
                                        trigger: "blur",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "select-item",
                                      attrs: {
                                        disabled: _vm.disabled,
                                        filterable: "",
                                        clearable: "",
                                        placeholder: "Select Account Type",
                                      },
                                      model: {
                                        value: _vm.form.beneficiary_type,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "beneficiary_type",
                                            $$v
                                          )
                                        },
                                        expression: "form.beneficiary_type",
                                      },
                                    },
                                    _vm._l(
                                      _vm.beneficiaryTypeOptions,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "mt-12",
                              attrs: {
                                label: _vm.$t("merchantAccount.account_no"),
                                prop: "disbursement_number",
                                rules: [
                                  {
                                    required: true,
                                    message: "Account No. cannot be empty",
                                    trigger: ["blur", "change"],
                                  },
                                  {
                                    validator: _vm.checkoutAccountNo,
                                    trigger: ["blur", "change"],
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "search-frame",
                                attrs: {
                                  disabled: _vm.disabled,
                                  placeholder: "Enter Account No.",
                                  maxlength: "50",
                                  autocomplete: "off",
                                  clearable: "",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.form.disbursement_number,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "disbursement_number",
                                      $$v
                                    )
                                  },
                                  expression: "form.disbursement_number",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11, offset: 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "mt-12",
                              attrs: {
                                label: _vm.$t("merchantAccount.short_name"),
                                prop: "disbursement_short_name",
                                rules: [
                                  {
                                    required: true,
                                    message: "Short name cannot be empty",
                                    trigger: ["blur", "change"],
                                  },
                                  {
                                    validator: _vm.checkWhitespace,
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "search-frame",
                                attrs: {
                                  disabled: _vm.disabled && !_vm.isEdit,
                                  placeholder: "Fill in the short name",
                                  maxlength: "64",
                                  autocomplete: "off",
                                  clearable: "",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.form.disbursement_short_name,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "disbursement_short_name",
                                      $$v
                                    )
                                  },
                                  expression: "form.disbursement_short_name",
                                },
                              }),
                              _vm.disabled && !_vm.isEdit
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "ml-20 confirm-btn-bg",
                                      attrs: { size: "small" },
                                      on: { click: _vm.onClickEditShort },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("components.edit")))]
                                  )
                                : _vm._e(),
                              _vm.isEdit
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "ml-20 confirm-btn-bg",
                                      attrs: { size: "small" },
                                      on: { click: _vm.onClickSubmit },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("components.confirm"))
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isEdit
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "ml-20 cancel-btn-bg",
                                      attrs: { size: "small" },
                                      on: { click: _vm.cancelShortName },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("components.cancel"))
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "merchantAccount.basic_company_information_of_beneficiary"
                          )
                        ) +
                        " "
                    ),
                  ]),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "mt-12",
                              attrs: {
                                label: _vm.$t(
                                  "merchantAccount.full_legal_entity_name_of_beneficiary"
                                ),
                                prop: "company_information_full_name",
                                rules: [
                                  {
                                    required: true,
                                    message:
                                      "Full Legal Entity Name Of Beneficiary cannot be empty",
                                    trigger: ["blur", "change"],
                                  },
                                  {
                                    validator: _vm.checkName,
                                    trigger: ["blur", "change"],
                                  },
                                  {
                                    validator: _vm.checkWhitespace,
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "search-frame",
                                attrs: {
                                  disabled: _vm.disabled,
                                  placeholder:
                                    "Enter Full Legal Entity Name Of Beneficiary",
                                  maxlength: "50",
                                  autocomplete: "off",
                                  clearable: "",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.form.company_information_full_name,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "company_information_full_name",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.company_information_full_name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11, offset: 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "merchantAccount.registered_country"
                                ),
                                prop: "company_information_registered_country",
                                rules: [
                                  {
                                    required: true,
                                    message:
                                      "Registered Country cannot be empty",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "select-item",
                                  attrs: {
                                    disabled: _vm.disabled,
                                    filterable: "",
                                    placeholder:
                                      "Enter Registered Country/Region",
                                    clearable: "",
                                  },
                                  model: {
                                    value:
                                      _vm.form
                                        .company_information_registered_country,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "company_information_registered_country",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.company_information_registered_country",
                                  },
                                },
                                _vm._l(
                                  _vm.onlineCountryList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label:
                                          _vm.language === "zh"
                                            ? item.cn_name
                                            : item.en_name,
                                        value: item.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "mt-12",
                              attrs: {
                                label: _vm.$t(
                                  "merchantAccount.registered_address"
                                ),
                                prop: "company_information_registered_address",
                                rules: [
                                  {
                                    required: true,
                                    message:
                                      "Registered Address cannot be empty",
                                    trigger: ["blur", "change"],
                                  },
                                  {
                                    validator: _vm.checkWhitespace,
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "search-frame",
                                attrs: {
                                  disabled: _vm.disabled,
                                  placeholder: "Enter Registered Address",
                                  maxlength: "50",
                                  autocomplete: "off",
                                  clearable: "",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value:
                                    _vm.form
                                      .company_information_registered_address,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "company_information_registered_address",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.company_information_registered_address",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("merchantAccount.authorized_representative")
                        ) +
                        " "
                    ),
                  ]),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "mt-12",
                              attrs: {
                                label: _vm.$t("merchantAccount.full_name"),
                                prop: "authorized_representative_full_name",
                                rules: [
                                  {
                                    required: true,
                                    message: "Full Name cannot be empty",
                                    trigger: ["blur", "change"],
                                  },
                                  {
                                    validator: _vm.checkName,
                                    trigger: ["blur", "change"],
                                  },
                                  {
                                    validator: _vm.checkWhitespace,
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "search-frame",
                                attrs: {
                                  disabled: _vm.disabled,
                                  placeholder: "Enter Full Name",
                                  maxlength: "50",
                                  autocomplete: "off",
                                  clearable: "",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value:
                                    _vm.form
                                      .authorized_representative_full_name,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "authorized_representative_full_name",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.authorized_representative_full_name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11, offset: 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "mt-12",
                              attrs: {
                                label: _vm.$t("merchantAccount.position"),
                                prop: "authorized_representative_position",
                                rules: [
                                  {
                                    required: true,
                                    message: "Position cannot be empty",
                                    trigger: ["blur", "change"],
                                  },
                                  {
                                    validator: _vm.checkWhitespace,
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "search-frame",
                                attrs: {
                                  disabled: _vm.disabled,
                                  placeholder: "Enter Position",
                                  maxlength: "64",
                                  autocomplete: "off",
                                  clearable: "",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value:
                                    _vm.form.authorized_representative_position,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "authorized_representative_position",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.authorized_representative_position",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _vm.dialogVisible
                            ? _c("UploadFileDrawingBoard", {
                                ref: "UploadFileDrawingBoard",
                                staticClass: "mt-20",
                                attrs: { disabled: _vm.disabled },
                                on: {
                                  uploadFileSuccess: _vm.uploadFileSuccess,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "mt-20 remarkLabel",
                              attrs: {
                                label: _vm.$t("data.remark"),
                                prop: "remark",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "tips.large_value_beneficiary_remark_tip"
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("el-input", {
                                attrs: {
                                  placeholder: "Enter your message here",
                                  type: "textarea",
                                  autocomplete: "off",
                                  maxlength: "256",
                                  disabled: _vm.disabled,
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.form.remark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "remark", $$v)
                                  },
                                  expression: "form.remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          !_vm.disabled
            ? _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-submit",
                      attrs: { type: "info", disabled: _vm.submiting },
                      on: {
                        click: function ($event) {
                          return _vm.onClickSubmitBtn()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("components.submit")))]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c("ContractDescriptionModal", { ref: "ContractDescriptionModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }